export default __webpack_public_path__ + "static/media/icon-wellness.83265862.svg";